module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// F:/Solutions/7572bo/master/~/axios/index.js
// module id = 75
// module chunks = 1